<template>
  <div>
    <ProductDetailMobile
      v-if="isMobile"
      :other-links="otherLinks"
      :state="state"
      :product="product"
      :return-title="returnTitle"
      :return-data="returnData"
      :asset-allocation-date="assetAllocationDate"
      :prospectus-url="prospectusUrl"
      :factsheet-url="factsheetUrl"
      :type-url="typeUrl"
      :mi-url="miUrl"
      :product-url="productUrl"
      :nav-date="navDate"
      :nav-value="navValue"
      @getProduct="getProduct"
      @goToBuyPage="goToBuyPage"
    />
    <ProductDetailDesktop
      v-else
      :other-links="otherLinks"
      :state="state"
      :product="product"
      :return-title="returnTitle"
      :return-data="returnData"
      :asset-allocation-date="assetAllocationDate"
      :breadcrumb-links="breadcrumbLinks"
      @getProduct="getProduct"
      @goToBuyPage="goToBuyPage"
    />
  </div>
</template>

<script>
import {
  generateOtherLinks,
  getMutualFundProductObject,
  generateBreadcrumbLinks,
  seoMapperConstant as CONSTANT,
  generateSeoInvestmentManagerUrl,
  generateSeoProductUrl,
  generateSeoTypeUrl,
} from 'shared/helpers/seoMap';
import api from 'shared/api';
import dayjs from 'dayjs';
import { money } from 'shared/helpers/numberHelper';
import isMobile from 'shared/mixins/isMobile';
import ProductDetailDesktop from '../../components/desktop/product/ProductDetail';
import ProductDetailMobile from '../../components/mobile/product/ProductDetail';

export default {
  name: 'ProductDetailPage',
  metaInfo() {
    return {
      title: this.mutualFundProductObject.meta_title,
      meta: [
        { name: 'description', content: this.mutualFundProductObject.meta_desc },
        { name: 'keyword', content: this.mutualFundProductObject.meta_keyword },
      ],
    };
  },
  components: {
    ProductDetailMobile,
    ProductDetailDesktop,
  },
  mixins: [isMobile],
  props: {
    detail: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      state: 'loading',
      product: {},
      returnTitle: ['1 Bulan', '6 Bulan', '1 Tahun', '3 Tahun', 'Awal Tahun', 'Awal Peluncuran'],
    };
  },
  computed: {
    assetAllocationDate() {
      return dayjs(this.product.asset_allocation_date).format('MMMM YYYY');
    },
    prospectusUrl() {
      return `${this.product.prospectus_url}`;
    },
    factsheetUrl() {
      return `${this.product.factsheet_url}`;
    },
    otherLinks() {
      return generateOtherLinks(this.page, CONSTANT.PRODUCT_KEY, this.mutualFundProductObject.type);
    },
    mutualFundProductObject() {
      return getMutualFundProductObject(this.detail);
    },
    page() {
      return this.mutualFundProductObject.key;
    },
    typeUrl() {
      return generateSeoTypeUrl(this.product.type);
    },
    miUrl() {
      return generateSeoInvestmentManagerUrl(this.product.im_code);
    },
    productUrl() {
      return generateSeoProductUrl(this.product.isin_code);
    },
    navDate() {
      return dayjs(this.product.last_nav_updated_at).format('DD MMMM YYYY');
    },
    navValue() {
      return money(this.product.last_nav_value);
    },
    returnData() {
      if (this.product.all_return) {
        return [
          this.product.all_return.one_month,
          this.product.all_return.six_month,
          this.product.all_return.one_year,
          this.product.all_return.three_year,
          this.product.all_return.year_to_date,
          this.product.all_return.inception,
        ];
      }
      return [];
    },
    breadcrumbLinks() {
      return generateBreadcrumbLinks(CONSTANT.PRODUCT_KEY, this.page);
    },
  },
  mounted() {
    this.getProduct();
  },
  methods: {
    getProduct() {
      this.state = 'loading';
      api
        .getProductDetail(this.mutualFundProductObject.isin)
        .then(response => {
          const { data } = response;
          if (data) {
            this.state = 'success';
            this.product = data;
          }
        })
        .catch(() => {
          this.state = 'error';
        });
    },
    goToBuyPage() {
      window.location.href = `/bukareksa/subscription/${this.product.isin_code}`;
    },
  },
};
</script>
